export default "__VITE_ASSET__BQwilAd4__";